// Shared navigation contract with the Game Development task.
// Only verified production games belong in this list.
export const games = [
  {
    id: 'drink-if-you-think',
    name: 'Drink If You Think',
    url: 'https://drinkifyouthink.com/',
    description: 'Two people. One prompt. Find out how well you know each other.'
  },
  {
    id: 'olympic-cup',
    name: 'Olympic Cup',
    url: 'https://cup.drinkifyouthink.com/',
    description: 'Team mini-games, guesses, dares, and a medal board.'
  },
  {
    id: 'after-hours',
    name: 'After Hours',
    url: 'https://afterhours.drinkifyouthink.com/',
    description: 'A story-led date-night game for two.'
  },
  {
    id: 'power',
    name: 'Power Hour',
    url: 'https://power.drinkifyouthink.com/',
    description: 'Your photos, messages, and prompts in a one-hour party mixtape.'
  }
];
